import { EquipmentType } from "../feature-modules/equipment/model/equipment.model";

export interface ISuccessError {
    modalTitle: string;
    isError: boolean;
    navigateTo: string;
    langKey: string;
    isLangKey:boolean;
}
export interface ICommonModal {
    commonModalBody: ICommonModalBody[];
    isCommonModalButton: boolean;
    isSignout?: boolean;
}
export interface ICommonModalBody {
    content: string;
    commonModalHrefLink: string;
}
export interface IGetAllUsersBody {
    offset: number;
    sortKey: string;
    sort: string;
    searchTerm?: string;
}
export interface ISearchDataBody {
    searchTerm: string;
    offset: number;
    sortKey: string;
    sort: string;
    advancedSearch?: boolean;
}
export interface IUpdateUserDataBody{
    "firstName":string,
    "lastName":string
}

export interface IUpdateSiteDataBody{
    "siteName":string,
    "siteType":string,
    "siteAddress": {
        "address1": string,
        "address2": string,
        "city": string,
        "state": string,
        "country": string,
        "postalCode": string

    },
    "timeZoneId": string,
    "timeZoneLabel": string
}

export interface ITimezones {
    [key: string]: string
}

export interface IUpdateSiteControllerBody{
    "controllerSn":any,
}

export interface IUpdateSiteUserDataBody{
    userId:number,
    role?:string,
    firstName?: string,
    lastname?:string,
    nickName?:string
}

export interface ISiteStatus{
    createdAt:any,
    ownerEmail: any,
    ownerId : any,
    ownerName : any,
    siteAddress : any,
    siteId : any,
    siteName :any,
    siteType :any,
    siteStatus: any
}

export interface Business {
    business_name: string;
    business_id: string;
    business_owner_first_name: string | null;
    business_owner_last_name: string | null;
    business_owner_email: string;
    business_function: string[];
    business_nick_name: string;
}

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    isOwner: boolean;
    name: string;
}

export interface IUpdateProBusinessBody{
    
        businessId: any,
        siteNickName: any,
        siteFunctions: any[]
    
}

export interface ProBusiness {
    businessId: any;
    businessName: any;
    email: any;
    firstName:any;
    lastName: any;
    isAdded: boolean;
}
export interface TelemetryData {
    outputName: string;
    id: string;
    unit: string;
    value: number;
    representation: string;
    category: TelemetryCategory | string;
    timestamp: number;
    spaceId: string;
  }

export type TelemetryCategory = 'sanitizer' | 'orpSensor' | 'phSensor'

export interface AsyncEvent {
    context: ContextType;
    payload: string; // JSON string that will be parsed based on context
    eventType: EventType;
    dataModelVersion: number;
    timestamp: number;
}

export type CommonPayload = 
  | EquipmentPayload
  | OutcomePayload
  | ScenePayload
  | SchedulePayload
  | SpacePayload
  | SystemPayload
  | ThermostatPayload
  | WaterQualityManagerPayload;

// Context type enum
type ContextType = 'equipment' | 'outcomes' | 'scenes' | 'schedules' | 'spaces' |
    'system' | 'thermostats' | 'waterQualityManagers' | 'cloud';

// Event type enum
type EventType = 'equipmentdetected' | 'equipmentstatusupdated' | 'equipmentremoved' |
                'outcomecreated' | 'outcomeupdated' |
                'scenecreated' | 'sceneupdated' |
                'schedulecreated' | 'scheduleupdated' |
                'spacecreated' | 'spaceupdated' |
                'systemupdated' |
                'thermostatcreated' | 'thermostatstatusupdated' |
                'waterqualitymanagercreated';

// Payload interfaces for different contexts
export interface EquipmentPayload {
    displayName?: string;
    id?: string;
    equipmentId?: string;
}

export interface OutcomePayload {
    outcomeName: string;
    outcomeId: string;
}

export interface ScenePayload {
    sceneName: string;
    sceneId: string;
}

export interface SchedulePayload {
    scheduleName: string;
    scheduleId: string;
}

export interface SpacePayload {
    spaceName: string;
    spaceId: string;
}

export interface SystemPayload {
    systemStatus: string;
}

export interface ThermostatPayload {
    thermostatName: string;
    thermostatId: string;
}

export interface WaterQualityManagerPayload {
    managerName: string;
    waterQualityManagerId: string;
}

// Main interface for the response
export interface AsyncEventsResponse {
    asyncEvents: AsyncEvent[];
}
export interface SensorGroup {
    sensorType: string;
    sensorItems: any[];
  }

export interface ControllerProfile {
    controllerSerialNumber: string;
    controllerName?:string,
    space:[],
    siteId?: string
    siteName?: any;
    isWaterFeature?:boolean;
    isSWC?:boolean;
    equipmentType?:string;
    isFilterationPump?:boolean;
}  
export interface EquipmentDetailResponse {
    displayName: string;
    siteName: any;
    controllerSerialNumber: string;
    controllerName?:string,
    space:[],
    pumpStatus : string;
    pumpAssign: string; 
    connectionStatus?: string; // Optional field for connection status
    equipmentDetails: EquipmentDetails;
    equipmentStatus?: any;
}

export interface EquipmentDetails {
    power:boolean;
    connectionStatus:boolean;
    generalSettings : GeneralSetting,
    configuration : Configuration,
    featureSettings?: FeatureSettings[]; 
    lightDiagnostics?: LightDiagnostics[];
    assignmentStatus?:string;
    diagnostics?: any;
    equipmentType?:string;
    controllerDiagnostics?: ControllerDiagnostics;
    equipmentStatus:EquipmentStatus;
    equipmentState?:any;
}
export interface MeasurementWithUnit {
    value: number;
    unit: string;
}
export interface ControllerDiagnostics {
    maxWattageCapacity?: number;
    installedWattage?: number;
    currentWattage?: number;
    currentAmps?: number | MeasurementWithUnit;
    inputVoltage?: number;
    boardTemperature?: number | MeasurementWithUnit;
    lightControllerDerating?: number;
}

export interface LightDiagnostics {
  id:string;
  modelName: string;
  model?: string;
  connectionStatus: DigitalLightConnectionStatus; 
  serialNumber: string;
  spaceId: string | null;
  spaceName: string | null;
  lightGroupId: string | null;
  lightGroup: string | null;
  temp: number | string | null;
  derating: number | string | null;
  brightness: number | null;
  rssi: number | null;
  installDate: string | null;

  // feature-profile specific fields
  lightControl: string | null;
  lightControllerId: string | null;
  maxBrightness: number | string | null;
}

export interface GeneralSetting {
    freezeSpeed: number;
    maxSpeed: number;
    minSpeed: number;
    primeDuration: number;
    primeSpeed: number;// Optional field for additional description
    isPrimingUntil?: number;
    equipmentType: EquipmentType;
    heaterCycleTime?: number;
    heaterCooldownTime?: number;   
}

// Low voltage equipment general settings interface keys are dynamic
export interface LowVoltageEquipmentGeneralSetting {
  [key: string]: {
      time: string;
      description: string;
  }
}

export interface Configuration {
    name:string,
    displayName:string,
    application: string;
    spaces: Space[];
    modelName: string;
    modelId: string;
    modelVersion: string;
    assignmentStatus?:string;
    serialNumber: string;
    manufacturer: string;
    firmwareVersion: string;
    controller: string;
    connectionType: string;
    address: number;
    valveConfiguration: any[]; // Assuming valveConfiguration is an array
    spilloverConfiguration: SpilloverConfiguration;
    equipmentType: EquipmentType;
    pumpStatus?: boolean;
    operationType?: string;
}
export interface Space {
  spaceId: string;
  displayName: string;
}

export interface SpilloverConfiguration {
  spilloverEnabled: boolean;
  standardSpilloverDirection: boolean;
  spillover?: string;
}

export interface FeatureSettings {
    featureId: string;
    featureName: string;
    featureCategory?: string;
    featureParameters?: FeatureParameters;
    isFreezeProtected: boolean;
    isVspAssociated?: boolean;
    isRpmVariable?: boolean;
  }
  
  export interface FeatureParameters {
    customSpeed: string;
    highSpeed: string;
    lowSpeed: string;
    mediumSpeed: string;
  }

   export interface Diagnostics {
    actualSpeed: number;
  }
  export enum EquipmentErrorStates {
    NeedsAttention = 'Needs Attention',
    ActionRequired = 'Action Required',
    Unconfigured = 'Unconfigured',
    Disconnected = 'Disconnected',
    Unavailable = 'Unavailable',
  }

  export interface EquipmentErrorStatus {
      errorState: EquipmentErrorStates | null;
      errorIcon: string;
  }

  export interface EquipmentStatus {
    state: string | boolean;
    targetSpeed?: number;
    priming?: boolean;
    heatingStatus?: string;
    targetColor?: string;
    power?: boolean;
    connectionStatus?: boolean;
    assignmentStatus?: string;
    isPriming?: boolean;
    isPrimingUntil?: number;
    primeDuration?: number;
    speed?: number;
    isfreezeProtection?: boolean;
    status?: string;
    errorStates?: string;
    heaterCooldown?: number;
  }

  
  export interface SpaceData {
    spaceName: string;
    spaceId: string;
  }
  
  export interface FeatureEquipment {
    id: string;
    displayName: string;
    type: string;
    equipmentStatus: EquipmentStatus;
    connectionStatus: boolean;
    category: string;
    spaceData?: SpaceData;
    serialNumber?: number;
    connectionType?: string;
    connectionPort?: string;
    address?: number | undefined;
    valveApplicationType?: string;
  }


  export enum SaltCellModelCode {
    Simple = 'TRUCLEAR11K',
    Smart = 'TRUCLEARXL',
    Unknown = 'UNKNOWN'
  }
  
  export const uiNameToCodeMapping: Record<string, SaltCellModelCode> = {
    simple: SaltCellModelCode.Simple,
    smart: SaltCellModelCode.Smart,
    unknown: SaltCellModelCode.Unknown
  };

  export enum ConnectionStatus {
    CONNECTED = 'Connected',
    DISCONNECTED = 'Disconnected',
    NEVER_CONNECTED = 'neverConnected'
  }

  export interface IEquipment {
    equipmentId: string;
    displayName: string;
    category: string;
    modelName: string;
    connectionStatus?: string;
    spaceId?: string | null;
    spaceType?: string;
    createdAt: string;
    updatedAt: string;
    equipmentUuid: string;
    equipmentType:string;
  }

  export interface IGroupedEquipmentsResponse {
    siteId: number;
    groups: Record<string, IEquipment[]>;
  }

  export interface ISpaceNameEquipmentsResponse {
    siteId: number;
    spaceName: string;
    equipmentList: IEquipment[];
  }

export type PresetSpeedKey = 'lowSpeed' | 'mediumSpeed' | 'highSpeed';

export interface Scene {
    sceneId: string;
    iconId: string;
    displayName: string;
    sceneStatus: string;
    sceneName: string;
}

export interface ScenesListResponse {
    scenes: Scene[];
}

export interface InfoRow {
  label: string;
  value?: string | number;
  fw?: string;
  ota?: string;

}
export enum BannerType {
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}
export interface BannerData {
  id: string;
  type: BannerType;
  title?: string;
  message?: string;
  translationKey?: string;
  iconSrc?: string;  
  htmlContent?: string;
  countdownEndTime?: number;
  countdownText?: string;
  data?: any; 
  isActive?: boolean;
  isIndefinite?: boolean;
}

export type WaterQualityStatus =
  | 'normal'
  | 'needsAttention'
  | 'actionRequired'
  | 'unknown';

export interface IPoolProUser {
  proContactId?: string;
  proGuestTechnicianId?: string;
  email: string;
  firstName: string;
  lastName: string;
  businessName: string;
  fluidraAccountNumber: string;
  contactType: TechnicianType;
  createdAt: string;
  businessId?: string;
  username:string;
  accessCode?: string;
}

export interface IAccessCode {
  access_code: string,
  site_id: string | null,
  user_id: number | null,
  pro_contact_id: string | null,
  created_at: string,
  updated_at: string
}

export interface IPoolProUsers {
  count: number;
  users: IPoolProUser[];
}

export enum TechnicianType {
  TECHNICIAN = 'TECHNICIAN',
  GUEST_TECHNICIAN = 'GUEST_TECHNICIAN',
  OWNER = 'OWNER'
}

export interface IPoolProUserDetails {
  sites: IPoolProUserSite[];
}

export interface IPoolProUserSite {
  siteId: number;
  siteUuid: string;
  siteNickName: string;
  siteAddress: IPoolProSiteAddress;
  siteOwner: IPoolProSiteOwner;
  customers: IPoolProCustomer[];
}

export interface IPoolProSiteAddress {
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface IPoolProSiteOwner {
  firstName: string;
  lastName: string;
}

export interface IPoolProCustomer {
  firstName: string;
  lastName: string;
}

export enum DigitalLightConnectionStatus {
  Connected = "Connected",
  Disconnected = "Disconnected",
  Unavailable = "Unavailable",
  NeedsAttention = "Needs Attention",
  ActionRequired = "Action Required",
}
export interface IActivationReason {
  outcomeId?: string;
  thermostatId?: string;
  name: string;
  executionState?: string;
  triggerType?: string;
}
